module.exports = __webpack_public_path__ + "img/dk.8cc783cf.svg";